/* Filtered Shopify collection export. fflate 0.8.2 is loaded only on download. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.mount(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function exportUrl(href, page) {
    var url = new URL(href);
    url.hash = '';
    url.searchParams.delete('sections');
    url.searchParams.delete('view');
    url.searchParams.set('section_id', 'collection-export-data');
    url.searchParams.set('page', String(page));
    return url;
  }
  async function collect(href, load, progress) {
    var rows = [], seen = new Set(), first;
    for (var page = 1; ; page++) {
      var data = await load(exportUrl(href, page));
      if (!data || !Array.isArray(data.rows) || data.page !== page || !Number.isInteger(data.total) || !Number.isInteger(data.pages)) throw new Error('The coffee list could not be loaded. Please try again.');
      if (!first) first = data;
      if (data.total > 25000 || data.pages > 100) throw new Error('Please narrow your filters before exporting this collection.');
      if (data.total !== first.total || data.pages !== first.pages || data.handle !== first.handle || data.currency !== first.currency) throw new Error('The coffee list changed during export. Please try again.');
      data.rows.forEach(function (row) {
        if (!row || !row.id || !Array.isArray(row.cells) || row.cells.length !== 7 || seen.has(row.id)) throw new Error('The coffee list changed during export. Please try again.');
        seen.add(row.id); rows.push(row);
      });
      if (progress) progress(rows.length, first.total);
      if (page >= first.pages) break;
      if (!data.rows.length) throw new Error('A results page was empty. Please try again.');
    }
    if (!rows.length) throw new Error('No coffees match your current filters.');
    if (rows.length !== first.total) throw new Error('Some coffees could not be loaded. Please try again.');
    return Object.assign({}, first, { rows: rows });
  }
  function xml(value) {
    return String(value == null ? '' : value).replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
  }
  function sheetRows(rows) {
    return rows.map(function (row, index) {
      var number = index + 8;
      return '<row r="' + number + '" ht="45" customHeight="1">' + row.cells.map(function (value, column) {
        var ref = String.fromCharCode(65 + column) + number;
        var style = column === 6 ? 8 : (column === 5 ? 6 : 5);
        var attrs = ' r="' + ref + '" s="' + style + '"';
        if (typeof value === 'number' && Number.isFinite(value)) return '<c' + attrs + '><v>' + value + '</v></c>';
        // Inline text never becomes a formula, even when it begins with =, +, - or @.
        return '<c' + attrs + ' t="inlineStr"><is><t xml:space="preserve">' + xml(value) + '</t></is></c>';
      }).join('') + '</row>';
    }).join('');
  }
  function workbook(template, rows, zip, decode) {
    var files = {};
    Object.keys(template.files).forEach(function (name) { files[name] = decode(template.files[name]); });
    var sheet = template.sheet.replace('<!--EXPORT_ROWS-->', sheetRows(rows)).replace(/A1:G7/g, 'A1:G' + (rows.length + 7)).replace(/A7:G7/g, 'A7:G' + (rows.length + 7));
    var links = [], relations = [];
    rows.forEach(function (row, index) {
      try {
        var url = new URL(row.cells[6]);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
        var id = 'exportLink' + index;
        links.push('<hyperlink ref="G' + (index + 8) + '" r:id="' + id + '"/>');
        relations.push('<Relationship Id="' + id + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="' + xml(url.href) + '" TargetMode="External"/>');
      } catch (_) { /* Leave non-URL text as plain text. */ }
    });
    if (links.length) {
      sheet = sheet.replace('</mergeCells>', '</mergeCells><hyperlinks>' + links.join('') + '</hyperlinks>');
      var relPath = 'xl/worksheets/_rels/sheet1.xml.rels';
      files[relPath] = zip.strToU8(zip.strFromU8(files[relPath]).replace('</Relationships>', relations.join('') + '</Relationships>'));
    }
    files['xl/worksheets/sheet1.xml'] = zip.strToU8(sheet);
    return zip.zipSync(files, { level: 6 });
  }
  function eventPayload(email, data, href, id) {
    var url = new URL(href), filters = {};
    url.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) (filters[key] || (filters[key] = [])).push(value);
    });
    return { data: { type: 'event', attributes: {
      unique_id: id,
      metric: { data: { type: 'metric', attributes: { name: 'Collection Export Downloaded' } } },
      profile: { data: { type: 'profile', attributes: { email: email } } },
      properties: { collection: data.collection, collection_handle: data.handle, collection_path: url.pathname, filters: filters, sort_by: url.searchParams.get('sort_by') || 'title-ascending', product_count: data.rows.length, product_ids: data.rows.map(function (r) { return r.id; }), currency: data.currency, file_type: 'xlsx', download_stage: 'browser_download_initiated' }
    } } };
  }
  function subscriptionPayload(email, listId) {
    return { data: { type: 'subscription', attributes: {
      custom_source: 'Collection export',
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: listId } } } } };
  }
  function trackingAllowed(win) {
    try { var p = win.Shopify.customerPrivacy; return !!(p && p.analyticsProcessingAllowed() && p.marketingAllowed()); } catch (_) { return false; }
  }
  function production(win, config) {
    return /^(www\.)?royalcoffee\.com$/.test(win.location.hostname) && !new URL(win.location.href).searchParams.has('preview_theme_id') && !config.designMode;
  }
  function mount(win) {
    var doc = win.document, configEl = doc.getElementById('rc-export-config');
    if (!configEl || win.rcCollectionExportInitialized) return;
    win.rcCollectionExportInitialized = true;
    var config = JSON.parse(configEl.textContent), dialog = doc.getElementById('rc-collection-export');
    var form = dialog.querySelector('form'), status = dialog.querySelector('[data-export-status]'), submit = form.querySelector('[type=submit]');
    var busy = false, assetsPromise, capturedUrl, lastTrigger;
    function say(message) { status.textContent = message; }
    async function fetchBounded(url, options) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 20000);
      try { return await win.fetch(url, Object.assign({}, options, { signal: controller.signal })); } finally { clearTimeout(timer); }
    }
    function assets() {
      if (!assetsPromise) assetsPromise = Promise.all([
        fetchBounded(config.templateUrl).then(function (r) { if (!r.ok) throw new Error('The Excel template could not be loaded. Please try again.'); return r.json(); }),
        new Promise(function (resolve, reject) {
          if (win.fflate) return resolve();
          var script = doc.createElement('script'), timer = setTimeout(fail, 20000);
          function fail() { clearTimeout(timer); script.remove(); reject(new Error('The Excel download could not be prepared. Please try again.')); }
          script.src = config.zipUrl; script.onload = function () { clearTimeout(timer); resolve(); }; script.onerror = fail; doc.head.appendChild(script);
        })
      ]).catch(function (error) { assetsPromise = null; throw error; });
      return assetsPromise;
    }
    async function post(endpoint, payload) {
      var response = await fetchBounded('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + encodeURIComponent(config.companyId), {
        method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' }, body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('Klaviyo request failed');
    }
    doc.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-collection-export-open]');
      if (!trigger || busy) return;
      lastTrigger = trigger; capturedUrl = win.location.href;
      say(''); submit.disabled = false; submit.textContent = 'Download Excel';
      dialog.showModal();
    });
    dialog.querySelector('[data-export-close]').addEventListener('click', function () { if (!busy) dialog.close(); });
    dialog.addEventListener('cancel', function (event) { if (busy) event.preventDefault(); });
    dialog.addEventListener('close', function () { if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus(); });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      busy = true; submit.disabled = true;
      var email = config.email || form.elements.email.value.trim();
      var subscribe = !!(form.elements.subscribe && form.elements.subscribe.checked);
      var downloaded = false;
      try {
        say('Preparing your coffee list…');
        var loaded = await assets();
        var data = await collect(capturedUrl, async function (url) {
          var response = await fetchBounded(url.href, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('A results page could not be loaded. Please try again.');
          var html = new DOMParser().parseFromString(await response.text(), 'text/html');
          var node = html.querySelector('[data-collection-export-page]');
          if (!node) throw new Error('The export is temporarily unavailable. Please try again.');
          return JSON.parse(node.textContent);
        }, function (count, total) { say('Preparing ' + count + ' of ' + total + ' coffees…'); });
        if (win.location.href !== capturedUrl) throw new Error('Your filters changed. Close this window and export again.');
        var bytes = workbook(loaded[0], data.rows, win.fflate, function (base64) { return Uint8Array.from(atob(base64), function (c) { return c.charCodeAt(0); }); });
        var blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var objectUrl = URL.createObjectURL(blob), link = doc.createElement('a');
        link.href = objectUrl;
        link.download = 'royal-coffee-' + data.handle.replace(/[^a-z0-9-]/gi, '') + '-' + data.currency + '-' + new Date().toISOString().slice(0, 10) + '.xlsx';
        doc.body.appendChild(link); link.click(); link.remove();
        setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 60000);
        downloaded = true;
        var message = 'Your Excel download has started.';
        say(message);
        if (production(win, config)) {
          if (trackingAllowed(win)) {
            try { await post('events', eventPayload(email, data, capturedUrl, win.crypto.randomUUID())); }
            catch (_) { message += ' We could not record the download at this time.'; }
          } else { message += ' Download tracking is off under your cookie preferences.'; }
          if (subscribe) {
            try { await post('subscriptions', subscriptionPayload(email, config.listId)); message += ' Newsletter signup received—check your inbox for any confirmation.'; }
            catch (_) { message += ' Newsletter signup could not be completed. Please use the newsletter form below.'; }
          }
        } else { message += ' Preview mode: email signup and tracking were not sent.'; }
        say(message);
      } catch (error) { say(error.name === 'AbortError' ? 'The request timed out. Please try again.' : error.message); }
      finally { busy = false; submit.disabled = downloaded; submit.textContent = downloaded ? 'Download started' : 'Download Excel'; }
    });
  }
  return { exportUrl: exportUrl, collect: collect, sheetRows: sheetRows, workbook: workbook, eventPayload: eventPayload, subscriptionPayload: subscriptionPayload, trackingAllowed: trackingAllowed, production: production, mount: mount };
});
